import Vue from 'vue'
import { HTTP } from '@/utils/httpCommonUtil'
import { BallPulseLoader } from 'vue-loaders';
import VueSimpleSpinner from 'vue-simple-spinner'
import facilityEventHub from '@/components/facility/FacilityEventHub';
import { getRestResponseErrorMessage } from '@/utils/serverErrorMessageUtil';
import flatPickr from 'vue-flatpickr-component';
import format from 'date-fns/format'
import { UserRoleEnum } from '@/enums/userRolesEnum'
import FacilityControl from '@/componentsReusable/FacilityControl.vue'
import UploadControl from '@/componentsReusable/UploadControl.vue'
import GenericModal from '@/componentsReusable/genericModal.vue'
import { convertDateStringToUTCDate } from '@/utils/dateUtil';
import MaskedInput from 'vue-text-mask'
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

export default Vue.component('facility-specialty-credentialed-providers-card', {
  name: 'FacilitySpecialtyCredentialedProvidersCard',
  data () {
    let emptyArray: Array<any> = [];
    return {
      cardExpanded: false,
      loadingInitialData: false,
      savingNewProvider: false,
      credentialedProviders: emptyArray,
      isAuthorizedToDelete: false,
      showConfirmationModal: false,
      pendingDeleteProvider: null,
      pendingProvider: null,
      feeMask: createNumberMask({
        prefix: '',
        allowDecimal: true,
        decimalLimit: 2,
        integerLimit: 4,
        thousandsSeparatorSymbol: ''
      }),
    }
  },
  components: {
    flatPickr,
    BallPulseLoader,
    VueSimpleSpinner,
    FacilityControl,
    UploadControl,
    GenericModal,
    MaskedInput
  },
  beforeMount: function () {
    this.isAuthorizedToDelete = this.$store.getters['user/hasRole']([UserRoleEnum.MANAGER]);
  },
  created: function () {
    facilityEventHub.$on('SPECIALTY_CHANGE', this.specialtyChangeEvent)
  },
  beforeDestroy: function () {
    facilityEventHub.$off('SPECIALTY_CHANGE', this.specialtyChangeEvent)
  },
  filters: {
    dateformat (dateISO: string) {
      if (!dateISO) { return 'na' }
      let tempString: string = format(dateISO, 'M.D.YY');
      return tempString;
    },
    miles (miles: any) {
      if (!miles) { return '(- miles)' }
      return '(' + miles + ' miles)';
    },
    state (state: any) {
      if (!state) { return '' }
      return ', ' + state;
    },
    billRate (billRate: any) {
      if (!billRate) { return 'BR: - ' }
      return 'BR: ' + (Vue as any).options.filters.currency(billRate) + ' - ';
    },
    payRate (payRate: any) {
      if (!payRate) { return 'PR: - ' }
      return 'PR: ' + (Vue as any).options.filters.currency(payRate);
    },
    phoneNumber (phoneNumber: string) {
      if (!phoneNumber) { return 'NA'; }
      let formattedPhoneNumber = phoneNumber;
      if (phoneNumber && phoneNumber.length) {
        let phoneNumberArray = phoneNumber.match(/(\d)?(\d\d\d)?(\d\d\d)(\d\d\d\d)$/);
        if (!phoneNumberArray) { return formattedPhoneNumber; }
        formattedPhoneNumber = phoneNumberArray.length ? '' : formattedPhoneNumber;
        for (let i = 1; i < phoneNumberArray.length; i++) {
          if (phoneNumberArray[i]) {
            formattedPhoneNumber += phoneNumberArray[i] + '.';
          }
        }
        formattedPhoneNumber = formattedPhoneNumber.slice(0,formattedPhoneNumber.length - 1);
      } else {
        formattedPhoneNumber = 'NA';
      }
      return formattedPhoneNumber;
    },
    nickname (nickName: string ) {
      if (nickName && nickName.length) {
        return '(' + nickName + ')';
      }
      return '';
    },
    title (title: string ) {
      if (title && title.length) {
        return ' | ' + title;
      }
      return '';
    },
  },
  methods: {
    specialtyChangeEvent () {
      setTimeout( () => {
        this.getCredentialedProviders()
      },0);
    },
    expandCard () {
      this.cardExpanded = !this.cardExpanded;
      if (this.cardExpanded) {
        this.getCredentialedProviders()
      }
    },
    getCredentialedProviders () {
      let showLoadingSpinnerTimeout = setTimeout(() => {
        this.loadingInitialData = true;
      }, 0);
      HTTP.get('/api/facilities/' + this.$route.params.facilityId + '/specialties/' + this.$route.params.specialtyId + '/credentialed-providers')
      .then((response) => {
        clearTimeout(showLoadingSpinnerTimeout);
        this.loadingInitialData = false;
        if (!response.data || !response.data.data) {
          throw new Error("Error retrieving Facility Providers.");
        }
        let freshCredentialedProviders = response.data.data;
        freshCredentialedProviders.forEach((credentialedProvider: any) => {
          credentialedProvider.isEditing = false;
          credentialedProvider.isNew = false;
          credentialedProvider.updatingData = false;
          credentialedProvider.hourlyBillRate = this.cleanseRate(credentialedProvider.hourlyBillRate);
          credentialedProvider.hourlyPayRate = this.cleanseRate(credentialedProvider.hourlyPayRate);
          credentialedProvider.hourlyHolidayBillRate = this.cleanseRate(credentialedProvider.hourlyHolidayBillRate);
          credentialedProvider.hourlyHolidayPayRate = this.cleanseRate(credentialedProvider.hourlyHolidayPayRate);
          credentialedProvider.issuedDate = convertDateStringToUTCDate(credentialedProvider.issuedDate);
          credentialedProvider.expirationDate = convertDateStringToUTCDate(credentialedProvider.expirationDate);
          credentialedProvider.expirationNoticeDate = credentialedProvider.expirationNoticeDate ? convertDateStringToUTCDate(credentialedProvider.expirationNoticeDate) : null ;
          credentialedProvider.expirationNoticeSentDate = convertDateStringToUTCDate(credentialedProvider.expirationNoticeSentDate);
        });

        this.credentialedProviders = freshCredentialedProviders;
      })
      .catch(err => {
        console.log('response Error! ' + err);
        clearTimeout(showLoadingSpinnerTimeout);
        this.loadingInitialData = false;
        this.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred retrieving Credentialed Providers.'
        });
      });
    },
    cleanseRate(rate?: any): string {
      if (rate === undefined || rate === null) {
        return '';
      }
      return '' + rate;
    },
    welcomeStatusChange (provider: any) {
      provider.isWelcomed = provider.isWelcomed === 'true' ? true : false;
    },
    expirationDateChange (provider: any, event: any) {
      let expDate = new Date(provider.expirationDate);
      if (provider.expirationNoticeSetting === "0") {
        provider.expirationNoticeDate = null;
      } else {
        expDate.setMonth(expDate.getMonth() - provider.expirationNoticeSetting);
        provider.expirationNoticeDate = expDate;
      }
    },
    facilitySelected (provider: any, facility: any) {
      provider.facilityId = facility.id;
      provider.facilityName = facility.name;
    },
    updateProvider (updatedProvider: any) {
      let self = this
      updatedProvider.updatingData = true;
      HTTP.put('/api/facilities/' + this.$route.params.facilityId + '/specialties/' + this.$route.params.specialtyId + '/credentialed-providers', updatedProvider)
      .then(function (response) {
        updatedProvider.updatingData = false;
        updatedProvider.isEditing = false;
        self.getCredentialedProviders();
      })
      .catch(function (error) {
        updatedProvider.updatingData = false;

        let generalError = getRestResponseErrorMessage(error);
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error Updating',
          text: generalError ? generalError : 'An error occurred updating provider.',
        });
      })
    },
    toggleEditProvider (provider: any) {
      let selectedCredId = provider.providerCredentialId;
      // Collapse any editing providers
      // Delete any existing "new" providers
      let indexesToDelete: any = [];
      this.credentialedProviders.forEach(function (cred, index) {
        if (cred.isNew) {
          indexesToDelete.push(index);
        }
        if (selectedCredId !== cred.providerCredentialId) {
          cred.isEditing = false;
        }
      });
      let self = this;
      indexesToDelete.forEach(function (indx: number) {
        self.credentialedProviders.splice(indx,1);
      })
      provider.isEditing = !provider.isEditing;
    },
    cancel (provider: any) {
      provider.isEditing = false;
      if (provider.isNew) {
        // Allow the editing UI to collapse before removing it from the array.
        let self = this;
        setTimeout(function () {
          self.credentialedProviders.shift();
        }, 300);
      } else {
        this.getCredentialedProviders();
      }
    },
    openAttachment (s3Key: string) {
      // get pre-signed url
      // open pre-signed url in a new tab
      let self = this
      HTTP.get('/api/s3/signed-url/get?s3key=' + s3Key)
      .then(function (response) {
        if (!response.data || !response.data.data) {
          throw new Error("Error getting attachment.");
        }
        console.log('signed URL: ' + response.data.data);
        window.open(response.data.data, '_blank');
      })
      .catch(function (err: any) {
        console.log('response Error!');
        console.log(err);
        // console.log(err.message);
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred saving uploaded file attachment.'
        });
      })
    },
    browseToProvider (iProvider: any, bypassBrowseConfirmation: boolean = true) {
      if (!bypassBrowseConfirmation) {
        // Show Browse Confirmation Modal
        this.showConfirmationModal = true;
        this.pendingProvider = iProvider;
        return;
      } else {
        this.pendingProvider = null;
      }

      window.open("/providers/" + iProvider.providerId, '_blank');
    },
    onCopy (param: any) {
      console.log('Copied!');
      console.log(param);
      this.$notify({
        group: 'main',
        type: 'success',
        title: 'Successfully Copied',
        text: 'Text ' + param.text + ' has been copied.',
      });
    },
    onError (param: any) {
      console.log('Error!');
      console.log(param);
      this.$notify({
        group: 'main',
        type: 'error',
        title: 'Error Copying',
        text: 'Something went wrong copying to your clipboard.',
      });
    },
    hourlyBillRateChange (provider: any) {
      if (!provider.hourlyHolidayBillRate) {
        provider.hourlyHolidayBillRate = !provider.hourlyBillRate ? '' : '' + (provider.hourlyBillRate * 1.5)
      }
    },
    hourlyPayRateChange (provider: any) {
      if (!provider.hourlyHolidayPayRate) {
        provider.hourlyHolidayPayRate = !provider.hourlyPayRate ? '' : '' + (provider.hourlyPayRate * 1.5)
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/facility/cards/facilitySpecialtyCredentialedProviders/FacilitySpecialtyCredentialedProvidersCard.ts